// 复制剪切板功能
import Vue from 'vue'

function clipboardSuccess() {
  Vue.prototype.$message.success('复制成功')
}

function clipboardError() {
  Vue.prototype.$message.error('复制失败')
}

export default function handleClipboard(text) {
  // 首先进行文本参数检查
  if (!text && text !== '') {
    console.warn('复制内容不能为空');
    return;
  }
  
  // 降级方案：直接使用传统的document.execCommand('copy')
  // 这种方式兼容性最好，避免了现代API的各种问题
  try {
    // 创建临时textarea元素
    const textArea = document.createElement('textarea');
    textArea.value = text;
    
    // 设置样式使其不可见但可复制
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    textArea.style.width = '2em';
    textArea.style.height = '2em';
    textArea.style.padding = '0';
    textArea.style.border = 'none';
    textArea.style.outline = 'none';
    textArea.style.boxShadow = 'none';
    textArea.style.background = 'transparent';
    
    // 添加到DOM并执行复制
    document.body.appendChild(textArea);
    
    // 保存当前活动元素
    const currentActiveElement = document.activeElement;
    
    // 选择文本并执行复制
    textArea.focus();
    // 处理长文本选择
    if (textArea.setSelectionRange) {
      textArea.setSelectionRange(0, text.length);
    } else {
      textArea.select();
    }
    
    // 执行复制命令
    let successful = false;
    try {
      successful = document.execCommand('copy');
    } catch (copyError) {
      console.warn('复制命令执行失败:', copyError);
    }
    
    // 恢复之前的活动元素
    if (currentActiveElement) {
      currentActiveElement.focus();
    }
    
    // 清理临时元素
    document.body.removeChild(textArea);
    
    // 显示结果
    if (successful) {
      clipboardSuccess();
    } else {
      clipboardError();
    }
  } catch (err) {
    console.error('复制过程发生错误:', err);
    clipboardError();
  }
}
